import { FetchAdapter } from "../FetchAdapter/FetchAdapter";
import { BugsnagAdapter } from "../BugsnagAdapter/index";

// we're using this method to invalidate browser http cache on some of our pages
export function switchLanguageAndReload(langCode) {
  FetchAdapter.get(`/locales?locale=${langCode}`)
    .catch((e) => { BugsnagAdapter.notify("SwitchLanguage", e); })
    .finally(() => { window.location.reload(); })
}
